/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Alerts component
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#alerts[_ngcontent-%COMP%]{position:fixed;bottom:0;left:0;right:0;z-index:999999}#alerts[_ngcontent-%COMP%]   .alert[_ngcontent-%COMP%]{border-radius:0}"];
export { styles as styles };
